import React from 'react';
import './FactionEnlightenedDescription.css';
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import {
  ENLIGHTENED_COINS_TO_WIN_POINTS_CONVERSION,
  ENLIGHTENED_STARTING_COINS_BONUS
} from "../../../../configs/factions/enlightened";
import {WinPointsStat} from "../../../PlayerStat/stats/WinPointsStat";
import {STARTING_COINS} from "../../../../configs/game";

const FactionEnlightenedDescription = () => {
  const startingCoins =
    <CoinsStat
      text={ENLIGHTENED_STARTING_COINS_BONUS + STARTING_COINS}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left'}
    />;

  const coinsPerWinPoint =
    <CoinsStat
      text={ENLIGHTENED_COINS_TO_WIN_POINTS_CONVERSION}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left'}
    />;

  const arrow = <img
    className={'from-to-icon policy-description-icon'}
    src={'/img/icons/up.png'}
    alt={'Обменять'}
    title={'Обменять'}
  />;

  const winPoint =
    <WinPointsStat
      text={1}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left'}
    />;

  const coinsIcon =
    <img
      className={'policy-description-icon policy-description-icon-margin-right-left'}
      src={'/img/icons/coins.png'}
      alt={'Монеты'}
      title={'Монеты'}
    />;

  const winPointsIcon =
    <img
      className={'policy-description-icon policy-description-icon-margin-right-left'}
      src={'/img/icons/win points.png'}
      alt={'Обменять'}
      title={'Обменять'}
    />;

  return (
    <>
      <div className="policy-description_line">
        Начинают игру с {startingCoins}.
      </div>
      <div className="policy-description_line policy-description_line-margin-top-paragraph">
        В конце игры обмен {coinsIcon} на {winPointsIcon} по курсу
      </div>
      <div className="policy-description_line">
        {coinsPerWinPoint}{arrow}{winPoint}
      </div>
    </>
  );
};

export default FactionEnlightenedDescription;
